import { render, staticRenderFns } from "./reportCommunitySpaceList.vue?vue&type=template&id=f33d1cd8&scoped=true"
import script from "./reportCommunitySpaceList.vue?vue&type=script&lang=js"
export * from "./reportCommunitySpaceList.vue?vue&type=script&lang=js"
import style0 from "./reportCommunitySpaceList.vue?vue&type=style&index=0&id=f33d1cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33d1cd8",
  null
  
)

export default component.exports